import { createTheme, Theme } from "@mui/material";
import { deepmerge } from "@mui/utils";

export const colors = {
  offWhite: '#F8F6F4',
  midGrey: '#D5D1CE',
  grey: '#838383',
  greyLight: '$offWhite',
  darkGrey: '#1E1E1E',
  leafGreenDigital: '#D4FF47',
  skyBlueDigital: '#0FC0FC',
  tangerine: '#FF8000',
  nightSky: '#001B6E',
  mint: '#09FBD3',
  flower: '#FF4571',
}


// const green = systemTheme.palette.augmentColor({
//   color: {
//     main: colors.green,
//     dark: colors.greenDark,
//     light: colors.greenLight
//   }
// })

export type ThemeColorKey = keyof typeof colors;
const theme = createTheme({
  palette: {
    primary: {
      main: colors.leafGreenDigital,
      // contrastText: colors.white
    },
    secondary: {
      main: colors.skyBlueDigital,
    },
    success: {
      main: colors.leafGreenDigital
    },
    info: {
      main: colors.skyBlueDigital
    },
    warning: {
      main: colors.tangerine
    },
    error: {
      main: colors.flower
    },
    // divider: '#C4C4C4'
  },
});

export const applyPalette = (baseTheme: Theme) => {
  baseTheme.palette = deepmerge(baseTheme.palette, theme.palette)
  return baseTheme;
};

export default theme;
